import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { login, register } from '../api/projects';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';
import '../styles/ICOListing.css';

import Navbar from '../components/Navbar';


export default function Auth() {
    const navigate = useNavigate();
    const { loginUser } = useAuth();
    const [tab, setTab] = useState('login');
    const [forgotEmail, setForgotEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [loginForm, setLoginForm] = useState({ email: '', password: '' });
    const [registerForm, setRegisterForm] = useState({ username: '', email: '', password: '', confirm: '', role: 'participant' });

    const [showPassword, setShowPassword] = useState(false);

    const handleLogin = async () => {
        setError(''); setLoading(true);
        if (!loginForm.email || !loginForm.password) { setError('Please fill in all fields.'); setLoading(false); return; }
        const result = await login(loginForm);
        if (result.success) {
            loginUser(result.user, result.token);
            const role = result.user?.role;
            if (role === 'admin') navigate('/admin');
            else if (role === 'client') navigate('/mon-compte');
            else navigate('/mon-espace');
        } else {
            setError(result.error || 'Login error');
        }
        setLoading(false);
    };

    const handleForgot = async () => {
        setError(''); setLoading(true);
        if (!forgotEmail) { setError('Please enter your email.'); setLoading(false); return; }
        try {
            const res = await fetch('/api/auth/forgot-password.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: forgotEmail }),
            });
            const data = await res.json();
            if (data.success) {
                setSuccess('If this email exists, a reset link has been sent.');
            } else {
                setError(data.error || 'An error occurred.');
            }
        } catch {
            setError('Unable to reach the server.');
        }
        setLoading(false);
    };

    const handleRegister = async () => {
        setError(''); setLoading(true);
        if (!registerForm.username || !registerForm.email || !registerForm.password) { setError('Please fill in all fields.'); setLoading(false); return; }
        if (registerForm.password !== registerForm.confirm) { setError('Passwords do not match.'); setLoading(false); return; }
        if (registerForm.password.length < 8) { setError('Password too short (minimum 8 characters).'); setLoading(false); return; }
        const result = await register(registerForm);
        if (result.success) {
            setSuccess('Account created! Check your email to activate your account.');
            setTab('login');
        } else {
            setError(result.error || 'Registration error');
        }
        setLoading(false);
    };

    return (
        <div className="app-wrap">
      <Helmet>
        <title>Sign In | OnlineICO</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

            <Navbar />

            <div className="auth-wrap">
                <div className="auth-card">
                    <div className="auth-title">ONLINEICO</div>
                    <div className="auth-subtitle">Access your project space</div>

                    <div className="auth-tabs">
                        <button className={`auth-tab${tab === 'login' ? ' active' : ''}`} onClick={() => { setTab('login'); setError(''); setSuccess(''); }}>Login</button>
                        <button className={`auth-tab${tab === 'register' ? ' active' : ''}`} onClick={() => { setTab('register'); setError(''); setSuccess(''); }}>Register</button>
                    </div>

                    {tab === 'forgot' && (
                        <div style={{ marginBottom: '4px' }}>
                            <button onClick={() => { setTab('login'); setError(''); setSuccess(''); }} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '0.82rem', cursor: 'pointer', padding: 0 }}>← Back to login</button>
                        </div>
                    )}

                    {error && <div className="auth-error">{error}</div>}
                    {success && <div className="auth-success">{success}</div>}

                    {tab === 'login' && (
                        <>
                            <div className="form-group">
                                <label className="form-label">Email</label>
                                <input className="form-input" type="email" placeholder="your@email.com" value={loginForm.email} onChange={e => setLoginForm(p => ({ ...p, email: e.target.value }))} />
                            </div>

                            <div className="form-group">
                                <label className="form-label">Password</label>
                                <div style={{ position: 'relative' }}>
                                    <input 
                                        className="form-input" 
                                        type={showPassword ? 'text' : 'password'} 
                                        placeholder="••••••••" 
                                        value={loginForm.password} 
                                        onChange={e => setLoginForm(p => ({ ...p, password: e.target.value }))} 
                                        onKeyDown={e => e.key === 'Enter' && handleLogin()}
                                        style={{ paddingRight: '40px' }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{
                                            position: 'absolute',
                                            right: '12px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: '#64748b',
                                            fontSize: '1.1rem',
                                            padding: 0
                                        }}
                                    >
                                        {showPassword ? '◉' : '○'}
                                    </button>
                                </div>
                            </div>

                            <button className="auth-btn" onClick={handleLogin} disabled={loading}>
                                {loading ? 'Logging in...' : 'Log in'}
                            </button>
                            <div style={{ textAlign: 'center', marginTop: '12px' }}>
                                <button onClick={() => { setTab('forgot'); setError(''); setSuccess(''); }} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '0.82rem', cursor: 'pointer', textDecoration: 'underline' }}>
                                    Forgot your password?
                                </button>
                            </div>
                        </>
                    )}




                    {tab === 'forgot' && (
                        <>
                            <div className="form-group">
                                <label className="form-label">Your email address</label>
                                <input className="form-input" type="email" placeholder="your@email.com" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleForgot()} />
                            </div>
                            <button className="auth-btn" onClick={handleForgot} disabled={loading}>
                                {loading ? 'Sending...' : 'Send reset link'}
                            </button>
                        </>
                    )}

                    {tab === 'register' && (
                        <>
                            {/* SÉLECTEUR DE RÔLE */}
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                                <div
                                    onClick={() => setRegisterForm(p => ({ ...p, role: 'participant' }))}
                                    style={{
                                        flex: 1, padding: '14px 10px', borderRadius: '14px', cursor: 'pointer', textAlign: 'center',
                                        border: registerForm.role === 'participant' ? '2px solid #8B5CF6' : '2px solid rgba(255,255,255,0.08)',
                                        background: registerForm.role === 'participant' ? 'rgba(139,92,246,0.12)' : 'rgba(255,255,255,0.03)',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    <div style={{ fontSize: '1.5rem', marginBottom: '4px' }}>🎯</div>
                                    <div style={{ fontSize: '0.78rem', fontWeight: '700', color: registerForm.role === 'participant' ? '#a78bfa' : '#94a3b8' }}>Participate</div>
                                    <div style={{ fontSize: '0.68rem', color: '#64748b', marginTop: '2px' }}>Do quests & earn</div>
                                </div>
                                <div
                                    onClick={() => setRegisterForm(p => ({ ...p, role: 'client' }))}
                                    style={{
                                        flex: 1, padding: '14px 10px', borderRadius: '14px', cursor: 'pointer', textAlign: 'center',
                                        border: registerForm.role === 'client' ? '2px solid #34D399' : '2px solid rgba(255,255,255,0.08)',
                                        background: registerForm.role === 'client' ? 'rgba(52,211,153,0.1)' : 'rgba(255,255,255,0.03)',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    <div style={{ fontSize: '1.5rem', marginBottom: '4px' }}>🚀</div>
                                    <div style={{ fontSize: '0.78rem', fontWeight: '700', color: registerForm.role === 'client' ? '#34D399' : '#94a3b8' }}>Submit a project</div>
                                    <div style={{ fontSize: '0.68rem', color: '#64748b', marginTop: '2px' }}>List your ICO/IDO</div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="form-label">Username <span style={{ color: '#EC4899' }}>*</span></label>
                                <input className="form-input" placeholder="Ex: cryptodev" value={registerForm.username} onChange={e => setRegisterForm(p => ({ ...p, username: e.target.value }))} />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Email <span style={{ color: '#EC4899' }}>*</span></label>
                                <input className="form-input" type="email" placeholder="your@email.com" value={registerForm.email} onChange={e => setRegisterForm(p => ({ ...p, email: e.target.value }))} />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Password <span style={{ color: '#EC4899' }}>*</span></label>
                                <input className="form-input" type="password" placeholder="Minimum 8 characters" value={registerForm.password} onChange={e => setRegisterForm(p => ({ ...p, password: e.target.value }))} />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Confirm password <span style={{ color: '#EC4899' }}>*</span></label>
                                <input className="form-input" type="password" placeholder="••••••••" value={registerForm.confirm} onChange={e => setRegisterForm(p => ({ ...p, confirm: e.target.value }))} onKeyDown={e => e.key === 'Enter' && handleRegister()} />
                            </div>
                            <button className="auth-btn" onClick={handleRegister} disabled={loading}>
                                {loading ? 'Creating...' : 'Create my account'}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}